import React from "react";
import {
    IGameContextViewModel
} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {GameWindowBox} from "../boxes/game-window.box";
import {GameBodyBox} from "../../game-body/boxes/body/game-body.box";
import {CyClass} from "../../../../../common/cy-classes";
import {GameFullScreenTapComponent} from "./full-screen-tap/game-full-screen-tap-component";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";
import {GameWindowInnerWrapperBox} from "../boxes/game-window-inner-wrapper.box";



interface GameWindowComponentProps extends ComponentServicesPick<'gameRunner'>{
    gameContext: IGameContextViewModel;
}

const ComponentBody: React.FC<GameWindowComponentProps> = observer((props) => {
    const _renderHeaderBar = () => {
        const headerBar = props.gameContext.gameParts.headerBarRenderer?.render();
        if(headerBar) {
            return headerBar;
        }
        return null;
    }

    const _renderFooterBar = () => {
        return props.gameContext.gameParts.footerBarRenderer?.render();
    }

    const _renderLeftBar = () => {
        return props.gameContext.gameParts.leftBarRenderer?.render();
    }

    const _renderRightBar = () => {
        return props.gameContext.gameParts.rightBarRenderer?.render();
    }

    const _renderJackpotBar = () => {
        return props.gameContext.gameParts.jackpotBarRenderer?.render();
    }

    const _captureGameBodyContainerElementRef = (element: HTMLElement) => {
        if(element) {
            props.gameContext.gameParts.bodyRenderer?.setGamePartElementRef(element);
        }
    }

    const _captureGameWindowElementRef = (element: HTMLElement) => {
        if(element) {
            props.gameContext.gameParts.windowRenderer?.setGamePartElementRef(element);
        }
    }

    const backgroundImage = props.gameContext.gameInfo.getBackgroundImage();

    // TODO: By Mircea for Mircea: In order to mitigate this flex column inside flex row try using a "display: grid"
    // And add left/right/top/bottom bars using grid area names
    return (
        <GameWindowBox key={`${props.gameContext.gameInfo.gameType}_${props.gameContext.gameMode}`}
                       className={CyClass('cy-game-window')}
                       zIndex={props.gameRunner.gameFrameZIndex}
                       ref={_captureGameWindowElementRef}>
            {_renderLeftBar()}

            <GameWindowInnerWrapperBox className="game_column_flex_wrapper">
                {_renderHeaderBar()}
                <GameBodyBox backgroundImageUrl={backgroundImage} ref={_captureGameBodyContainerElementRef}>
                    {props.gameContext.gameParts.bodyRenderer?.render()}
                </GameBodyBox>
                {_renderJackpotBar()}
                {_renderFooterBar()}
            </GameWindowInnerWrapperBox>

            {_renderRightBar()}
            <GameFullScreenTapComponent/>
        </GameWindowBox>
    );
})

export const GamePlayWindowComponent = withServices(ComponentBody, ['gameRunner']);